export default {
    key: 'harder-kulm',
    type: 'P2P',
    isUsingProductConfigPresets: false,
    isUsingProductPresets: true,
    hideCrossSells: false,
    disablePassengers: false,
    origins: [],
    destinations: [
        {
            ref: 'urn:uic:stn:8507369',
            name: 'Harder Kulm',
        },
    ],
    returnOrigins: [],
    returnDestinations: [],
    isRoundtrip: 'optional',
    canSwitchDirection: true,
    canChooseReturnDestination: false,
    isUsingReductionCards: true,
    isUsingKeyCards: false,
    isUsingPromos: true,
    isPromotionRequired: false,
    hasEPR: false,
    routeVariants: [],
    routeVariantUp: 'default-harder',
    routeVariantDown: 'default-harder',
    upsells: [],
    isUpsellDatesRestricted: false,
    isUsingSeasonDates: false,
    departureTimeIteration: 30,
    departureTimeDefaultMin: 420,
    stayDurationIteration: 30,
    stayDurationPopular: 90,
    stayDurationMin: 30,
    salesTimeLimit: 1285, // 21:25
    maxNumberOfPeople: 10,
    maxNumberOfPeopleGroupTariff: 10,
    defaultPassengerAge: 30,
    hiddenProductReductionCard: undefined,
    listingId: 'urn:listing:trips:harder-kulm',
    isLocalListing: true,
    steps: [
        {
            routeName: 'offerFlow-harder-kulm-steps-step-1-date',
            name: 'offerFlow.pages.stepDate.name.common',
        },
        {
            routeName: 'offerFlow-harder-kulm-steps-step-2-trip-selection',
            name: 'offerFlow.pages.stepTripSelection.name.common',
        },
        {
            routeName: 'offerFlow-harder-kulm-steps-step-4-passengers',
            name: 'offerFlow.pages.stepPassengers.name.common',
            skipIfUpsell: true,
        },
    ],
} satisfies ProductConfigP2P;
